/**
 * Speed unit helpers for Telematics UI.
 * Canonical live API / truth store speed is km/h; UK fleet UI shows mph.
 */

export const KPH_TO_MPH = 0.621371;

/** Colour-band edges for Vehicle Status speed chips (mph; ~20 / 60 / 100 km/h). */
export const SPEED_MPH_BAND_SLOW = 12;
export const SPEED_MPH_BAND_MODERATE = 37;
export const SPEED_MPH_BAND_FAST = 62;

/** Convert km/h → mph. Returns null when input is missing/non-finite. */
export function kphToMph(kph: number | null | undefined): number | null {
  if (kph == null || !Number.isFinite(kph)) return null;
  return kph * KPH_TO_MPH;
}

/** Round mph for table chips (whole mph). */
export function roundSpeedMph(kph: number | null | undefined): number | null {
  const mph = kphToMph(kph);
  if (mph == null) return null;
  return Math.round(mph);
}

/** Format API speed (km/h) for map popovers as "N.N mph". */
export function formatSpeedMphDetail(speedKph: number | null | undefined): string | null {
  const mph = kphToMph(speedKph);
  if (mph == null) return null;
  return `${mph.toFixed(1)} mph`;
}
